import {EnvironmentAdmin} from 'compob2b-libs';

export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  serverPicturesPath = 'https://dam.a101.ru/pictures';
  serverDocumentsPath = 'https://dam.a101.ru/documents';
  serverApi = 'https://dam.a101.ru/api/v1';
  serverUrl = 'https://dam.a101.ru';
  impersonate = false;
  accessRolesCatalog = false;
  enableWorkflowButton = true;
  showDiscountPanel = true;
  damShowCatalogInListing = true;
  compreface = true;
  damChangeLog = true;
}

export const environment = new EnvironmentAdminProd();
